import { Avatar, IconButton, Stack, useTheme } from "@mui/material";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { useUserImage } from "../../queries/user-settings/UseUserImage";
import { useSaveUserImage } from "../../queries/user-settings/UseSaveUserImage";
import { useConfirmation } from "../../contexts/confirmation-context/ConfirmationContext";
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
import { PhotoCamera } from "@mui/icons-material";
import { ChangeEvent } from "react";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { useTranslation } from "react-i18next";

export default function UserProfileAvatar() {

    const { t } = useTranslation();
    const [userState] = useUserContext();
    const [offlineState ] = useOfflineDetectContext();
    const { acknowledge } = useConfirmation();

    const theme = useTheme();    
        const routeContext = useRouteContext();
    
    const {data: userImage} = useQueryNotifications(useUserImage)({
        userID: userState.user?.id as number
    });

    const { mutate: saveUserImage } = useQueryNotifications(useSaveUserImage)({
        onSuccess: () => {
            acknowledge(t('profile.userImageUploaded'));
        }
    });

    const onUploadFile = (event: ChangeEvent<HTMLInputElement> ) => {

        if (event.target.files) {
            const file = event.target.files[0];

            saveUserImage({
                groupID: routeContext.groupID as number,
                userID: userState.user?.id as number,
                file
            });
        }
    };

    return (
        <Stack
            id='a'
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flex: '1 1 auto'
            }}>
            <Stack sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                flex: '0 0 100px'
            }}>
                    <Avatar sx={{ 
                                width: theme.spacing(8),
                                height: theme.spacing(8),
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                //paddingTop: 1,
                                //paddingBottom: 1
                                }} 
                                alt={userState.user?.displayText} 
                                src={(userImage?.length ?? 0) > 0 ? userImage : undefined} 
                            />

                    {
                        !offlineState.offline && 
                        <>
                            <input accept="image/*" style={{display: 'none'}} id="icon-button-file" type="file" onChange={onUploadFile} />
                            <label style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            //bottom: '-8px',
                            //right: '-18px'
                            }} htmlFor="icon-button-file">
                                <IconButton sx={{ 
                                    padding: 0,
                                    opacity: .8
                                    }}
                                    color="primary" aria-label="upload picture" component="span">
                                    <PhotoCamera />
                                </IconButton>
                            </label>
                        </>                        
                    
                    }
            </Stack>
            {/* <Typography fontWeight="bold" variant='h5' marginLeft={2} >
                    {userState.user?.displayText}
            </Typography> */}
        </Stack>
    );
}